module.exports = __webpack_public_path__ + "static/large_web-5287a8b704bc6ab56f45458da5f562a9.png";